<template>
  <div class="">
    <app-banner v-if="$store.state.ban"></app-banner>
    <app-t></app-t>
    <app-nav ref="onBlur"></app-nav>
    <app-Tiny />
    <router-view
      :style="[
        $store.state.ban
          ? { 'padding-top': '4.4em' }
          : { 'padding-top': '0em' },
      ]"
    ></router-view>
    <app-footer></app-footer>
    <app-error404 v-if="$store.state.e404"></app-error404>
    <app-error500 v-if="$store.state.e500"></app-error500>
    <div v-if="$store.state.graybg" class="graybg"></div>
    <div class="vld-parent">
      <loading
        :active.sync="this.$store.state.load"
        color="var(--sub-color)"
        background-color="white"
        :is-full-page="fullPage"
      >
      </loading>
    </div>
  </div>
  <!-- <app-test></app-test> -->
</template>

<script>
import banner from "./components/main/banner.vue";
import tinyModal from "./components/tinyModal/tinyModal.vue";
import nav from "./components/main/nav.vue";
import t from "./components/main/t.vue";
import footer from "./components/main/footer.vue";
import e404 from "./components/errors/404.vue";
import e500 from "./components/errors/500.vue";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  data() {
    return {
      ban: true,
      isLoading: true,
      fullPage: true,
    };
  },

  mounted() {
    // var ban = false;
  },
  metaInfo() {
    return {
      // title: `${this.userData.name} - فروشگاه شمع خورشید`,
      // link: [{ rel: "icon", href: this.$store.state.logo }]
      // link: [
      //   {
      //     rel: "icon",
      //     href:
      //       "http://95.217.80.85/media/images/pages/base/suncandle_2NYXb8p.jpg"
      //   }
      // ]
    };
  },

  components: {
    appTiny: tinyModal,
    appBanner: banner,
    appError404: e404,
    appError500: e500,
    Loading,
    appNav: nav,
    appT: t,
    appFooter: footer,
  },
  created() {},
};
</script>

<style lang="scss">
@import url("./style/var.scss");
@import url("./style/main.scss");
.vhome {
  padding-top: 4.4em !important;
}
.vhome1 {
  padding-top: 8.4em !important;
}
.graybg {
  width: 100%;
  height: 100vh;
  background: gray;
  opacity: 0.4;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/App.vue